import { render, staticRenderFns } from "./WaterLeakageCauseLocalizedQuestion.vue?vue&type=template&id=0a2904c2&scoped=true"
import script from "./WaterLeakageCauseLocalizedQuestion.vue?vue&type=script&lang=ts"
export * from "./WaterLeakageCauseLocalizedQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2904c2",
  null
  
)

export default component.exports